module.exports = __webpack_public_path__ + "img/page_title_2.8ee07c5c.png";